import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Availability, AvailabilityService, BuyBtnComponent, Product, ProductService } from 'gung-standard';
import { first, forkJoin, of } from 'rxjs';
import { ColmecRimOptionsModalComponent } from '../colmec-rim-options-modal/colmec-rim-options-modal.component';

@Component({
  selector: 'colmec-buy-btn',
  templateUrl: './colmec-buy-btn.component.html',
  styleUrls: ['./colmec-buy-btn.component.scss'],
  standalone: false
})
export class ColmecBuyBtnComponent extends BuyBtnComponent implements OnInit {
  private availabilityService = inject(AvailabilityService);
  private modalService = inject(NgbModal);
  private productService = inject(ProductService);

  @Input()
  product: Product;

  public isDisabled: boolean;
  public colmecHasRimOptions: boolean;

  public maximumOrder: number;
  isUser = false;

  ngOnInit(): void {
    super.ngOnInit();

    this.colmecHasRimOptions = this.product.extra._colmecIsConfigurable;
    const av = this.getProductAvailability(this.product);
    forkJoin({
      roles: this.authService.getRoles().pipe(first()),
      availability: !!av ? of(av) : this.availabilityService.getAvailability(this.id).pipe(first())
    }).subscribe(({ roles, availability }) => {
      const isView = roles.indexOf('VIEW') > -1;
      this.isDisabled = isView;
      this.isUser = roles.indexOf('USER') > -1 && roles.indexOf('ADMIN') === -1 && roles.indexOf('SALES') === -1;
      this.setIsDisabled(availability);
      this.getMaximumOrder(availability);
    });
  }

  openRimModal() {
    if (!!this.product.extra.pim) {
      this.openModal(this.id, this.product.extra.pim);
    } else {
      this.productService
        .getProduct(this.id)
        .pipe(first())
        .subscribe(product => this.openModal(this.id, product.extra.pim));
    }
  }

  private setIsDisabled(availability: Availability): void {
    if (availability.currentStock <= 0 && availability.currentAvailability === 100000) {
      this.isDisabled = true;
    } else if (availability.currentAvailability <= 0) {
      // STOCK_STATUS === (OUT_OF_STOCK OR INCOMMING)
      this.isDisabled = true;
    }
  }

  private getProductAvailability(product: Product): Availability {
    if (product.extra.availabilities) {
      const availabilities = Object.keys(product.extra.availabilities).map(key => product.extra.availabilities[key]);
      if (availabilities.length > 0) {
        return availabilities[0];
      }
    }

    return null;
  }

  private openModal(parentProductId: string, pim: any): void {
    const modalRef = this.modalService.open(ColmecRimOptionsModalComponent, {
      windowClass: 'modal-rim',
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.rimIds = pim._colmecRimProducts.split(',');
    modalRef.componentInstance.parentProductId = parentProductId;
    modalRef.componentInstance.assemblyProductsIds = pim._colmecAssemblyProducts
      ? pim._colmecAssemblyProducts.split(',')
      : [];
    modalRef.result.then(
      (result: string) => {},
      reason => {}
    );
  }

  getMaximumOrder(availability: Availability) {
    if (this.isUser) {
      this.maximumOrder = availability.currentAvailability;
    }
  }

  add() {
    if (this.isUser && this.maximumOrder) {
      if (!this.currentQty && this.stepAmount > this.maximumOrder) {
        return;
      }
      if (this.currentQty && this.currentQty + this.stepAmount > this.maximumOrder) {
        return;
      }
    }

    super.add();
  }

  set(value: number, inputElement?) {
    if (this.isUser && this.maximumOrder) {
      if (value > this.maximumOrder) {
        this.currentQty = value = inputElement.value = this.previousQty;
        this.cartService.setProductQuantity(this.id, this.previousQty, this.targetStockId, this.productPartialId);
        return;
      }
    }

    super.set(value);
  }
}
